module.exports = __webpack_public_path__ + "img/carousel-arrow-left.4666a02d.svg";